var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loading-spinner-container",class:_setup.containerClass},[_c('div',{staticClass:"loading-spinner"}),(_vm.text)?_c('p',{staticClass:"loading-text"},[_vm._v(_vm._s(_vm.text))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }